import { Month } from "../data/types/sum";
import { StoreState } from "../store";
import {
  FarmDetailsState,
  PriorProduction
} from "../reducers/farmDetailsReducer";
import { checkCompletelyInsideVic } from "../data/api/plantation/types";

export const renderDate = (date: Date) =>
  `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

// AUSelectItem Format required { value: '2010', text: '2010' }
export const yearToSelectItem = (y: number) => ({
  value: String(y),
  text: String(y)
});
export const monthToSelect = (m: Month) => ({ value: m, text: m });

export const renderNumber = (number: Number) => {
  let result = Number.isNaN(number) ? "-" : `${number.toLocaleString()}`;
  return result;
};

export const preventDefault = (fn: Function) => (evt: Event) => {
  evt.preventDefault();
  fn();
};

// return true if all required input checked (true or false), if any is not check (null), return false
const hasRequiredInputChecked = (farmDetails: FarmDetailsState): boolean => {
  if (farmDetails.previousProduction === null) return false;
  if (farmDetails.previousProduction === PriorProduction.PlantationForest) {
    if (
      checkCompletelyInsideVic(farmDetails) &&
      farmDetails.plantationRotation === null
    )
      return false;
  }
  if (farmDetails.previousProduction === PriorProduction.Pasture) {
    if (farmDetails.pastureRenovation === null) return false;
  }
  if (
    [
      PriorProduction.Crop,
      PriorProduction.Cotton,
      PriorProduction.Vegetables,
      PriorProduction.SugerCane,
      PriorProduction.Horticulture
    ].indexOf(farmDetails.previousProduction as PriorProduction) >= 0
  ) {
    if (farmDetails.stubbleRevoval === null) return false;
  }
  if (
    farmDetails.previousProduction !== PriorProduction.NativeForest &&
    farmDetails.previousProduction !== PriorProduction.PlantationForest
  ) {
    if (farmDetails.fertiliser === null) return false;
    if (farmDetails.lime === null) return false;
    if (farmDetails.irrigation === null) return false;
    if (
      farmDetails.irrigation === false &&
      farmDetails.irrigationDuringCarbon === null
    )
      return false;
  }
  return true;
};
export const routeStatus = (state: StoreState) => ({
  methodDiscoveryStatus:
    state.farmDetails.sa2s.length > 0 &&
    hasRequiredInputChecked(state.farmDetails),
  methodExplorationStatus: !!state.methodDiscovery.selectedProject
});
